
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1105Dialog extends Serenity.EntityDialog<Report_1105Row, any> {
        protected getFormKey() { return Report_1105Form.formKey; }
        protected getIdProperty() { return Report_1105Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1105Row.localTextPrefix; }
        protected getNameProperty() { return Report_1105Row.nameProperty; }
        protected getService() { return Report_1105Service.baseUrl; }
        protected getDeletePermission() { return Report_1105Row.deletePermission; }
        protected getInsertPermission() { return Report_1105Row.insertPermission; }
        protected getUpdatePermission() { return Report_1105Row.updatePermission; }

        protected form = new Report_1105Form(this.idPrefix);

    }
}